export default __webpack_public_path__ + "static/media/close.562dc126.svg";